import { get, post, type RequestConfig } from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  BhojanAddDonationPayload,
  BhojanDonation,
} from "@project/types/bhojan";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/bhojan-donations`;
const SILENT: RequestConfig = { showNotification: false };

class BhojanDonationService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<BhojanDonation>> =>
    fetchListPage<BhojanDonation>(`${BASE}/`, query);

  get = async (id: number): Promise<BhojanDonation | undefined> => {
    const data = await get<ApiItemResponse<BhojanDonation> | BhojanDonation>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  add = async (
    payload: BhojanAddDonationPayload
  ): Promise<BhojanDonation | undefined> => {
    const data = await post<
      ApiItemResponse<BhojanDonation> | BhojanDonation,
      BhojanAddDonationPayload
    >(`${BASE}/add/`, payload, SILENT);
    return unwrapItem(data);
  };
}

export const bhojanDonationService = new BhojanDonationService();
